import { Movax } from './Movax';
import Mustache from 'mustache';

/**
 * Parameters that are used in app
 */
interface Params {
  type: any;
  productType: string;
  product: string;
}

export class MaterialBankApp implements Params {
  private el;
  private ajaxEndpoint: string = '/stage-ajax/materialbank';
  private jsProductTypeSelect: string = 'js-v3-app-material-bank-product-type';
  private jsProductSelect: string = 'js-v3-app-material-bank-product';
  private jsTypeButtons: string = 'js-v3-app-material-bank-buttons';
  private jsList: string = 'js-v3-app-material-bank-list';
  private jsTemplate: string = 'js-v3-app-material-bank-item';
  private list;
  private typeButtons;
  private template;
  private productTypeSelect;
  private productSelect;
  public params;
  public limit: number = 4;
  public url: any;
  public location: any = document.location;

  type: Array<string>;
  productType: string;
  product: string;

  constructor(materialBankElement) {
    this.el = document.querySelector(materialBankElement);
  }

  /**
   * Init app
   * @returns false if app element not found
   */
  public init() {
    if (!this.el) {
      return;
    }

    this.list = this.el.querySelector('.' + this.jsList);
    this.template = this.el.querySelector('.' + this.jsTemplate);
    this.productTypeSelect = this.el.querySelector('.' + this.jsProductTypeSelect);
    this.productSelect = this.el.querySelector('.' + this.jsProductSelect);
    this.typeButtons = this.el.querySelectorAll('.' + this.jsTypeButtons + ' button');
    this.params = {};
    this.url = new URLSearchParams(new URL(this.location).search);

    if (this.list && this.template) {
      this.activateApp();
    }
  }

  /**
   * Activate app (launch element listeners for buttons and selects and render app)
   */
  private activateApp() {
    this.params = {
      type: (this.url.get('type') ? this.url.get('type').split(',') : []),
      productType: this.url.get('productType') || this.productType,
      product: this.url.get('product') || this.product,
      'stage-language': document.querySelector('html').getAttribute('lang')
    }
    this.elementListeners();
    this.render(this.getResults());
  }

  /**
   * Set listeners for specific elements
   */
  private elementListeners() {
    this.productTypeSelect.addEventListener('change', (e) => {
      this.params.productType = e.currentTarget.value;
      this.getResults();
    });
    this.productSelect.addEventListener('change', (e) => {
      this.params.product = e.currentTarget.value;
      this.getResults();
    });
    this.typeButtons.forEach((button) => {
      const value = button.getAttribute('data-value');
      this.refreshButtons();
      button.addEventListener('click', (e) => {
        if (value === 'copy') {
          navigator.clipboard.writeText(window.location.href);
        } else if (value === 'all') {
          this.params.type = [];
          this.getResults();
        } else {
          if (this.params.type.includes(value)) {
            this.params.type = this.params.type.filter(item => item !== value);
          } else {
            this.params.type.push(value);
          }
          this.getResults();
        }
        this.refreshButtons();
      });
    });
    this.params.productType ? this.productTypeSelect.value = this.params.productType : [];
    this.params.product ? this.productSelect.value = this.params.product : [];
  }

  /**
   * Refresh state of buttons
   */
  private refreshButtons() {
    this.typeButtons.forEach((button) => {
      const value = button.getAttribute('data-value');
      button.classList.remove('button--dark-blue', 'button--gray', 'button--text-blue');
      if (this.params.type.length > 0) {
        if (this.params.type.includes(value)) {
          button.classList.add('button--dark-blue');
        } else {
          button.classList.add('button--gray', 'button--text-blue');
        }
      } else {
        if (value === 'all') {
          button.classList.add('button--dark-blue');
        } else {
          button.classList.add('button--gray', 'button--text-blue');
        }
      }
    });
  }

  /**
   * Get materials from endpoint (stage-ajax)
   * @returns array of items from endpoint
   */
  private getResults() {
    this.params.type = this.params.type === 'all' ? null : this.params.type;
    for (const [key, value] of Object.entries(this.params)) {
      !value ? delete this.params[key] : [];
    }
    this.updateURL()
    return this.render(Movax.xhr.get(this.ajaxEndpoint, this.params));
  }

  /**
   * Render results to page
   * @param items array of items (materials)
   */
  private async render(items) {
    const result = await items;

    if (result) {
      let html = '';
      for (const [key, value] of Object.entries(result)) {
        html += Mustache.render(this.template.innerHTML, {
          ... result[key],
          heading: result[key].name,
          items: result[key].materials.map(material => {
            material.iconHtml = '';
            // material.downloadLink = '#';
            return material;
          }),
        });

        // if (result[key].materials.length > this.limit) {
        //   html += `<div class="txt-center"><button class="js-v3-app-material-bank-load-more button button--accent">${result[key].loadMoreLabel}</button></div>`;
        // }
      };

      this.list.innerHTML = html;
      // this.hideBeyondLimit();
      // this.addLoadMoreListeners();
    }
  }

  /**
   * Hides elements that goes beyond limit (this.limit)
   */
  private hideBeyondLimit() {
    this.el.querySelectorAll('.js-material-bank').forEach((bank) => {
      const bankItems = bank.querySelectorAll('.js-material-bank__item');
      if (bankItems.length > this.limit) {
        let counter = 0;
        bankItems.forEach((item) => {
          counter++;
          if (counter > this.limit) {
            item.style.display = 'none';
          }
        });
      }
    });
  }

  /**
   * Adds listeners to load more buttons
   */
  private addLoadMoreListeners() {
    this.list.querySelectorAll('.js-v3-app-material-bank-load-more').forEach((button) => {
      button.addEventListener('click', (e) => {
        e.currentTarget.parentElement.previousElementSibling.querySelectorAll('.js-material-bank__item').forEach((item) => {
          item.style.display = 'block';
          button.style.display = 'none';
        })
      });
    });
  }

  /**
   * Updates url
   */
  private updateURL() {
    window.history.replaceState({}, '', `${location.pathname}`); // Reset
    this.url = new URLSearchParams(new URL(this.location).search); // Reset
    for (const [key, value] of Object.entries(this.params)) {
      if (key !== 'stage-language') {
        this.url.set(key, value.toString());
      }
    }
    window.history.replaceState({}, '', `${location.pathname}?${this.url}`);
  }
}
